module.exports = __webpack_public_path__ + "02_glasses_black.bb7a8437.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer4/02_glasses_black.png
// module id = 21gm
// module chunks = 0